import { render, staticRenderFns } from "./OrdersCreateUnregistered.vue?vue&type=template&id=0b50a535&scoped=true&"
import script from "./OrdersCreateUnregistered.vue?vue&type=script&lang=js&"
export * from "./OrdersCreateUnregistered.vue?vue&type=script&lang=js&"
import style0 from "./OrdersCreateUnregistered.vue?vue&type=style&index=0&id=0b50a535&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b50a535",
  null
  
)

export default component.exports